import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Icon from 'react-fa';
import EnabledFeaturesStore from '../stores/EnabledFeaturesStore';

const getState = () => ({
  enabledFeatures: EnabledFeaturesStore.getState(),
});

export default class HeaderButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    this.enabledFeaturesSubscription = EnabledFeaturesStore.addListener(this._onChange);
  }

  componentWillUnmount() {
    this.enabledFeaturesSubscription.remove();
  }

  _onChange() {
    this.setState(getState());
  }

  tooltip(id, message) {
    return (
      <Tooltip id={id}>{message}</Tooltip>
    );
  }

  render() {
    if (this.props.viewerMode) {
      return (
        <span>
          <OverlayTrigger placement='bottom' overlay={this.tooltip('header-tooltip-logout', 'Log Out')}>
            <LinkContainer to='/logout' >
              <Button bsStyle='primary' className='overview header-button'><Icon name='sign-out' /></Button>
            </LinkContainer>
          </OverlayTrigger>
          <OverlayTrigger placement='bottom' overlay={this.tooltip('header-tooltip-admin', 'Administration')}>
            <LinkContainer to='/admin'>
              <Button bsStyle='primary' className='overview' ><Icon name='gear' /></Button>
            </LinkContainer>
          </OverlayTrigger>
          {
            this.state.enabledFeatures.content && (
              <OverlayTrigger placement='bottom' overlay={this.tooltip('header-tooltip-reports', 'Content')}>
                <LinkContainer to='/content'>
                  <Button bsStyle='primary' className='overview' ><Icon name='book' /></Button>
                </LinkContainer>
              </OverlayTrigger>
            )
          }
          <OverlayTrigger placement='bottom' overlay={this.tooltip('header-tooltip-reports', 'Reports')}>
            <LinkContainer to='/tableau'>
              <Button bsStyle='primary' className='overview' ><Icon name='bar-chart' /></Button>
            </LinkContainer>
          </OverlayTrigger>
        </span>
      );
    }
    return null;
  }
}

HeaderButtons.propTypes = {
  viewerMode: PropTypes.bool,
};
